// ─── Which way a block of outside text runs ──────────────────────────────────
//
// dir="auto" decides by the FIRST strong letter. A translated headline often
// opens with the company's name in Latin letters ("Apple (AAPL) מתכננת …"),
// and dir="auto" then lays the whole Hebrew sentence out left to right: the
// question mark jumps to the wrong end and the ticker's brackets flip
// (2026-09-26). So a block of text from a source is RTL when it contains any
// Hebrew letter, and LTR when it contains none · the same rule <Headline>
// already used. Text with no letters at all is left to the browser.

const HE = /[֐-׿]/;
const LATIN = /[A-Za-z]/;

export function dirOf(text) {
  const t = typeof text === "string" ? text : "";
  if (HE.test(t)) return "rtl";
  if (LATIN.test(t)) return "ltr";
  return "auto";
}
